function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0008 9.99993C11.7681 9.99993 13.2007 8.56725 13.2007 6.79995C13.2007 5.03265 11.7681 3.59998 10.0008 3.59998C8.23346 3.59998 6.80078 5.03265 6.80078 6.79995C6.80078 8.56725 8.23346 9.99993 10.0008 9.99993Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0014 2.39998C9.6894 2.39998 9.44141 2.15198 9.44141 1.83999V0.559996C9.44141 0.247998 9.6894 0 10.0014 0C10.3134 0 10.5614 0.247998 10.5614 0.559996V1.83999C10.5614 2.15198 10.3134 2.39998 10.0014 2.39998Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.3984 6.79999C14.3984 6.48799 14.6464 6.23999 14.9584 6.23999H16.2384C16.5504 6.23999 16.7984 6.48799 16.7984 6.79999C16.7984 7.11198 16.5504 7.35998 16.2384 7.35998H14.9584C14.6464 7.35998 14.3984 7.11198 14.3984 6.79999Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M3.19922 6.79999C3.19922 6.48799 3.44722 6.23999 3.75921 6.23999H5.0392C5.3512 6.23999 5.5992 6.48799 5.5992 6.79999C5.5992 7.11198 5.3512 7.35998 5.0392 7.35998H3.75921C3.44722 7.35998 3.19922 7.11198 3.19922 6.79999Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1112 3.68794C12.8952 3.47194 12.8952 3.11195 13.1112 2.89595L14.0152 1.99195C14.2312 1.77596 14.5912 1.77596 14.8072 1.99195C15.0232 2.20795 15.0232 2.56795 14.8072 2.78395L13.9032 3.68794C13.6872 3.90394 13.3272 3.90394 13.1112 3.68794Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M6.88923 3.68794C6.67324 3.90394 6.31324 3.90394 6.09724 3.68794L5.19325 2.78395C4.97725 2.56795 4.97725 2.20795 5.19325 1.99195C5.40925 1.77596 5.76924 1.77596 5.98524 1.99195L6.88923 2.89595C7.10523 3.11195 7.10523 3.47194 6.88923 3.68794Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M1.26562 14.0638C2.97761 17.1278 6.24159 19.1998 10.0016 19.1998C10.2896 19.1998 10.5616 19.1838 10.8415 19.1598C8.52957 16.3198 5.12159 14.4078 1.26562 14.0638Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M0 9.19995C0 9.75195 0.0559996 10.2799 0.143999 10.8079C5.95995 10.8559 11.0959 13.8079 14.1759 18.2799C14.6639 18.0559 15.1439 17.7999 15.5839 17.4959C12.1999 12.4959 6.47995 9.19995 0 9.19995Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M0.304688 11.6158C0.440686 12.1758 0.624685 12.7198 0.856683 13.2478C5.29665 13.5038 9.20862 15.7198 11.7446 19.0398C12.3206 18.9358 12.8726 18.7838 13.4086 18.5918C10.4966 14.4478 5.72065 11.7198 0.304688 11.6158Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2097 12.6799C14.5137 11.5039 17.1057 10.8319 19.8576 10.8079C19.9456 10.2799 20.0016 9.75195 20.0016 9.19995C16.6417 9.19995 13.4977 10.0879 10.7617 11.6399C11.2657 11.9679 11.7457 12.3119 12.2097 12.6799Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M19.6949 11.616C17.2549 11.664 14.9509 12.2479 12.8789 13.2479C13.3109 13.6239 13.7349 14.0239 14.1349 14.4399C15.6789 13.7679 17.3669 13.3519 19.1349 13.2479C19.4389 12.5519 19.7349 11.432 19.6949 11.616Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M18.7351 14.0638C17.3191 14.1918 15.9671 14.5358 14.7031 15.0558C15.2471 15.6718 15.7591 16.3278 16.2231 17.0158C17.2311 16.1998 18.0951 15.2078 18.7351 14.0638Z"
});

function SvgCrops(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "#A8B8CA",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrops);
export default __webpack_public_path__ + "static/media/crops.a1e50c38.svg";
export { ForwardRef as ReactComponent };